// extracted by mini-css-extract-plugin
module.exports = {"container":"DeeplinkLogin_container__uv5Us","email":"DeeplinkLogin_email__UNBAR","organization":"DeeplinkLogin_organization__hRQh0"};